import { getLocaleCountryLabel } from './getLocaleCountryLabel';

export function createCurrentCountryLabel(
  preferredLocation: string | undefined,
  locale: string | undefined
) {
  // Use page locale for country names so SSR and client hydration match.
  const countryLabel = getLocaleCountryLabel(
    preferredLocation ?? locale,
    locale
  );
  const languageCode = locale?.split('-')?.[0] ?? locale;

  if (countryLabel === languageCode) {
    return countryLabel;
  }

  return [countryLabel, languageCode].join(' - ');
}
